import { memo } from 'react';

import { FileStatusButton, FileStatusIconErrored, FileStatusTitle } from '@air/feature-file-status/ui';
import { Close } from '@air/next-icons';

import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';

export type DeleteBoardFailedPanelItemProps = {
  onClear: () => void;
};

export const DeleteBoardFailedPanelItem = memo(({ onClear }: DeleteBoardFailedPanelItemProps) => {
  return (
    <PaneItemTW
      avatar={<FileStatusIconErrored />}
      title={<FileStatusTitle>Failed to delete board!</FileStatusTitle>}
      buttons={
        <FileStatusButton label="Clear" onClick={onClear}>
          <Close className="size-4" />
        </FileStatusButton>
      }
    />
  );
});

DeleteBoardFailedPanelItem.displayName = 'DeleteBoardFailedPanelItem';
